export default "__VITE_ASSET__4311bb82__"